import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="customer-service">
        <ul>
          <h3>Customer Service</h3>
          <li>
            <a href="#shipping-policy">Shipping & Delivery Policy</a>
          </li>
          <li>
            <a href="#return-bags">
              Return, Exchange and Refunds policy for Bags
            </a>
          </li>
          <li>
            <a href="#return-heels">
              Return, Exchange and Refunds policy for Heels
            </a>
          </li>
          <li>
            <a href="#privacy-policy">Privacy Policy</a>
          </li>
          <li>
            <a href="#color-variation">Color Variation and Wear Tear</a>
          </li>
          <li>
            <a href="#terms-service">Terms of Service</a>
          </li>
          <li>
            <a href="#intellectual-property">
              Intellectual Property & Trademarks
            </a>
          </li>
          <li>
            <a href="#contact-us">Contact Us</a>
          </li>
        </ul>
      </div>
      <div className="footer-bottom">
        <p>© RASHKI</p>
        <p>Design by Marstechs</p>
      </div>
    </footer>
  );
};

export default Footer;
